/* eslint new-cap: ["error", { "capIsNew": false }]*/
import { List, fromJS } from 'immutable';
import { RestAPI } from '../../../util/net';
import { goBack } from '../../../util/util.jsx';
import { putError } from '../../../store/error.store';
import { markStoreLoading, markStoreLoaded } from '@/store/storeForStoringStatusOfStores.store';

export const usersLoaded = (state, action) =>
  state.clear().merge(fromJS(action.data));

export const userUpdated = (state, action) =>
  state.map(user =>
    (user.get('id') == action.data.id ?
      user.merge(fromJS(action.data).set('id', Number(action.data.id)).delete('password')) : user));

export const clearUsers = (state) => state.clear();

const userDeleted = (state, action) =>
  state.delete(state.findIndex(item => item.get('id') == action.id));

const userCreated = (state, action) => state.push(fromJS(action.data));

export const usersInfoReducer = (state = new List(), action) => {
  switch (action.type) {
    case 'CLEAR_USERS':
      return clearUsers(state, action);
    case 'USERS_LOADED':
      return usersLoaded(state, action);
    case 'USER_UPDATED_SUCCESSFULLY':
      return userUpdated(state, action);
    case 'USER_DELETED':
      return userDeleted(state, action);
    case 'USER_CREATED_SUCCESSFULLY':
      return userCreated(state, action);
    default:
      return state;
  }
};

export const deleteUser = (dispatch, id) => {
  dispatch({ type: 'USER_DELETE_STARTED' });
  return RestAPI.delete(`/users/api/${id}`)
    .then(() => { dispatch({ type: 'USER_DELETED', id }); return true; })
    .catch((data) => {
      dispatch({ type: 'USER_DELETE_FAILED' });
      putError(dispatch, data);
      return true;
    });
};

export const loadUsers = (dispatch) => {
  markStoreLoading(dispatch, 'users');
  dispatch({ type: 'USER_LOADING_STARTED' });
  return RestAPI.get('/users/api/').then((data) => {
    dispatch({ type: 'USERS_LOADED', data });
    markStoreLoaded(dispatch, 'users');
    return true;
  });
};

export const updateUser = (dispatch, userDto) => {
  dispatch({ type: 'USER_UPDATE_STARTED', data: userDto });
  return RestAPI.patch(`/users/api/${userDto.id}`, userDto)
    .then(
      () => {
        dispatch({ type: 'USER_UPDATED_SUCCESSFULLY', data: userDto });
        goBack(`/management/users/${userDto.id}`);
        return true;
      }
    ).catch(
      (data) => {
        if (data.status === 400) {
          if (data.password || data.email) {
            putError(dispatch, {...data, exception: false, popupHidden: true});
          }
        } else {
          putError(dispatch, data);
        }
        dispatch({ type: 'USER_UPDATE_FAILED' });
        return true;
      }
    );
};

export const updateProfile = (dispatch, userDto) => {
  dispatch({ type: 'USER_PROFILE_STARTED', data: userDto });
  return RestAPI.patch('/users/profile/api/', userDto)
    .then(
      () => {
        dispatch({ type: 'PROFILE_UPDATED_SUCCESSFULLY', data: userDto });
        goBack();
        return true;
      }
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'PROFILE_UPDATE_FAILED' });
        return true;
      }
    );
};

export const createUser = (dispatch, userDto) => {
  dispatch({ type: 'USER_CREATION_STARTED', data: userDto });
  return RestAPI.post('/users/api', userDto)
    .then(
      (response) => {
        dispatch({ type: 'USER_CREATED_SUCCESSFULLY', data: response });
        goBack(`management/users/${response.id}`);
        return true;
      }
    ).catch(
      (data) => {
        data.popupHidden = true; // eslint-disable-line
        putError(dispatch, data);
        dispatch({ type: 'USER_CREATION_FAILED' });
        return false;
      }
    );
};

export const usersSelectLoaded = (state, action) =>
  state.clear().merge(fromJS(action.data));

export const usersSelectReducer = (state = List(), action) => {
  switch (action.type) {
    case 'USERS_SELECT_LOADED':
      return usersSelectLoaded(state, action);
    default:
      return state;
  }
};

export const loadSelectData = (dispatch) => {
  markStoreLoading(dispatch, 'users_select');
  dispatch({ type: 'USER_SELECT_LOADING_STARTED' });
  return RestAPI.get('/users/select/api/').then((data) => {
    dispatch({ type: 'USERS_SELECT_LOADED', data });
    markStoreLoaded(dispatch, 'users_select');
    return true;
  });
};
